import React, { useEffect, useState } from "react";
import { Button, Datagrid, FunctionField, TextField, useRecordContext, useRedirect } from "react-admin";
import {
  CurriculumDisicplineTypes,
  DISCIPLINES,
  FOR_UPDATE,
  StudentServicePath,
  WEEKLY_SCHEDULE,
} from "utils/constants";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { Chip } from "@mui/material";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import dataProvider from "server/dataProvider";

const getDisciplineTypeColor = type => {
  switch (type) {
    case CurriculumDisicplineTypes.Facultative:
      return "#f4ecd7";
    case CurriculumDisicplineTypes.Elective:
      return "#d7f4fa";
    default:
      return null;
  }
};

const WeeklyScheduleExpanded = () => {
  const record = useRecordContext();
  const redirect = useRedirect();
  const notifyError = useNotifyError();

  const [disciplines, setDisciplines] = useState([]);

  const handleAdd = ({ disciplineId }) => {
    redirect(
      `/${StudentServicePath}${WEEKLY_SCHEDULE}/create?disciplineId=${disciplineId}` +
        `&curriculumId=${record.curriculumId}&studyTypeId=${record.studyTypeId}&academicYearSessionId=${record.academicYearSessionId}` +
        `&instructionLanguageId=${record.instructionLanguageId}&academicYearId=${record.academicYearId}` +
        `&specialityId=${record.specialityId}`,
    );
  };

  useEffect(() => {
    dataProvider
      .customRequest(studentRequests.getWeeklyScheduleExpanded(record.id), null, "GET")
      .then(data => setDisciplines(data.data))
      .catch(notifyError);
  }, [record.id, notifyError]);

  return (
    <Datagrid
      data={disciplines}
      rowClick={false}
      bulkActionButtons={false}
    >
      <FunctionField
        label="Код"
        render={rec =>
          rec.curriculumDisciplineTypeName && (
            <Chip
              label={rec.curriculumDisciplineTypeName}
              size="small"
              sx={{ bgcolor: getDisciplineTypeColor(rec.curriculumDisciplineType) }}
            />
          )
        }
      />

      <TextField
        source="disciplineName"
        label="Дисциплини"
      />
      <FunctionField
        label="Въведено разписание?"
        textAlign="center"
        render={record => (record.hasSchedule ? <CheckIcon color="success" /> : <ClearIcon color="error" />)}
      />

      <FunctionField
        label=""
        textAlign="center"
        render={rec =>
          rec.hasSchedule ? (
            <SecuredComponent permission={permissions.canUpdateEverythingInWeeklySchedules}>
              <Button
                onClick={() =>
                  redirect(
                    `/${StudentServicePath}${WEEKLY_SCHEDULE}/${rec.weeklyScheduleId}/${DISCIPLINES}/${rec.disciplineId}/${FOR_UPDATE}?curriculumId=${record?.curriculumId}&specialityId=${record?.specialityId}&academicYearSessionId=${record?.academicYearSessionId}`,
                  )
                }
                size="small"
                variant="contained"
                label="Редактирай"
                color="warning"
              >
                <EditIcon />
              </Button>
            </SecuredComponent>
          ) : (
            <Button
              onClick={() => handleAdd({ disciplineId: rec.disciplineId })}
              size="small"
              variant="contained"
              label="Добави"
            >
              <AddIcon />
            </Button>
          )
        }
      />
    </Datagrid>
  );
};

export default WeeklyScheduleExpanded;
